import React from "react";
import styled, { css } from "styled-components";
import _ from "lodash";

import { Text } from "src/library/components/Text";
import { sentenceCase } from "src/library/utils";

import { MinOrderQtySetting } from "./MinimumOrderQuantitySetting";

export interface MinimumOrderQuantityDisplayOnlyProps {
  /** The min quantity setting value */
  settingValue: Record<string, number>;
}

/**
 * Retruns a component that renders all set minimum order quantity values used for displaying
 * @returns
 */
const MinimumOrderQuantityDisplayOnly: React.FunctionComponent<MinimumOrderQuantityDisplayOnlyProps> = ({ settingValue }) => {
  // Transform the data into a shape we can map over
  const minOrderQtySettings: MinOrderQtySetting[] = React.useMemo(() => {
    const transformedData = _.map(settingValue, (value, key) => ({
      code: key,
      minQuantity: value
    }));

    // Sort the array alphabetically, except for the "quantity" code which should always be first
    transformedData.sort((a, b) => {
      if (a.code === "quantity") return -1;

      if (b.code === "quantity") return 1;

      return a.code.localeCompare(b.code);
    });

    return transformedData;
  }, [ settingValue ]);

  return (
    <StyledWrapper>
      {minOrderQtySettings.length ? minOrderQtySettings.map(minQtySetting => (
        <span
          className="recorded-min-qty"
          key={`${minQtySetting.code}`}
        >
          <Text
            weight="bold"
            className="item"
          >
            {`${minQtySetting.code === "quantity" ? "Order" : sentenceCase(minQtySetting.code)} quantity:`}
          </Text>

          <Text
            weight="bold"
            className="item-qty"
          >
            {minQtySetting.minQuantity}
          </Text>

        </span>
      )) : null}
    </StyledWrapper>
  );
};

const StyledWrapper = styled.span`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing.margins.md};
    weight: ${theme.fonts.weights.normal};
    .recorded-min-qty {
      display: flex;
      align-items: center;
      max-width: 400px;
    }

    .item-qty {
      margin-left: ${theme.spacing.margins.sm};
    }
  `}
`;

export default MinimumOrderQuantityDisplayOnly;
